module.exports = __webpack_public_path__ + "static/media/S_9.4b09e43e.png";